import cx from 'classix';

export const CohortRow = ({
  cohort,
  isSelected,
  onSelect,
}: {
  cohort: { id: number; name: string };
  isSelected: boolean;
  onSelect: (id: number) => void;
}) => (
  <button
    type='button'
    onClick={() => onSelect(cohort.id)}
    className={cx(
      'w-full text-left px-4 py-3 text-base text-gray-700 outline-none',
      isSelected ? 'bg-secondary-brand-30' : 'hover:bg-gray-50',
    )}
  >
    {cohort.name}
  </button>
);
